import CreditCardImage from './CreditCardImage.jsx'

export default CreditCardImage;
